import appClient from './AppClient';
import { endpoints } from '../../../config';

export default class DocumentService {
    getXmlDocumentContent(packageId: string) {
        const url = endpoints.manageUrl + `packages/${packageId}/xml`;
        return appClient.get<string>(url, 'text');
    }
}
